/*
 * @fileOverView homepage component definition
 */

import Vue from 'vue';
import EventBus from 'utils/EventBus';

Vue.component('homepage-vue', {
  data: function() {
    return {
      splashEnded: false,
      splashSkipped: false
    }
  },

  created() {
    // Adds a class that triggers transitions.
    EventBus.$on('splashscreen-video-ended', () => {
      this.splashEnded = true;
    });

    // Adds a class that skips transitions.
    EventBus.$on('splashscreen-video-skipped', () => {
      this.splashSkipped = true;
    });
  },

  mounted() {
    // Skips transitions if there isn't a splash screen on the page.
    if (!this.$children.filter(child => child.$refs.splashScreen).length) {
      this.splashSkipped = true;
    }
  }
});
